import { legacyTimeline } from "@/mocks/legacy";

export default function Legacy() {
  return (
    <section
      id="legacy"
      className="w-full bg-background-50 py-10 md:py-12 lg:py-14"
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="text-center mb-8 md:mb-10">
          <p className="text-xs font-semibold tracking-widest uppercase text-primary-600 mb-4">
            Our Journey
          </p>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950">
            A Legacy of Industry Engagement
          </h2>
        </div>

        {/* Timeline */}
        <div className="relative">
          {/* Desktop connecting line */}
          <div className="hidden lg:block absolute top-[72px] left-0 right-0 h-px bg-background-300" />

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6 md:gap-8">
            {legacyTimeline.map((item, index) => (
              <div key={item.year} className="relative flex flex-col">
                {/* Year marker */}
                <div className="flex items-center gap-3 lg:flex-col lg:items-center lg:gap-0 mb-3 lg:mb-0">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-500 text-white font-heading font-bold text-sm shrink-0 lg:mb-4">
                    {item.year}
                  </div>
                  {/* Mobile connector */}
                  {index < legacyTimeline.length - 1 && (
                    <div className="lg:hidden flex-1 h-px bg-background-300" />
                  )}
                </div>

                {/* Content */}
                <div className="lg:mt-6 lg:text-center">
                  <h3 className="text-base font-heading font-semibold text-foreground-950 mb-2">
                    {item.title}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {item.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}